import GenericModelLoader from "./GenericModelLoader";
import SqftJsonApi from "../../../../../../api/sqftJsonApi";

class CountertopLoader extends GenericModelLoader {
  constructor(opts) {
    super(opts);
  }

  async getUrl(data) {
    const cp = await SqftJsonApi.getCountertops(data, {});
    if (!cp || !cp.s3Url) {
      console.log('No URL for countertop at position', data);
      return null;
    }
    return cp.s3Url;
  }

  getModelPosition(data) {
    return {
      x: 0,
      y: data.y * this.modelScale,
      z: 0
    }
  }

  async postProcess(inst, data) {
    return this.applyTextureToInstance(inst, data);
  }
}

export default CountertopLoader;
